import React, { Component, lazy, Suspense } from "react";
import { connect } from "react-redux";
import "./MainContent.css";

import HomePage from "./HomePage";
import GettingStarted from "./GettingStarted/GettingStarted";
// import GettingStarted2 from "./GettingStarted/GettingStartedForUsers";
// import GettingStarted3 from "./GettingStarted/GettingStartedForUsersWithSMR";
import DashboardRoute from "./Dashboard/DashboardRoute";
import TemporaryPage from "./Dashboard/TemporaryPage";
import ResearchPage from "./Dashboard/ResearchPage";
import CollectionsPostsPage from "./Collections/CollectionsPostsPage";
// import PageNotFound from "../PageNotFound/PageNotFound";
import Loader from "../Loader/Loader";
import SubscriptionRoute from "../SubscriptionModule/SubscriptionRoute";
// import SubscriptionPlan from "../SubscriptionModule/SubscriptionPlan";
// import SubscriptionHistory from "../SubscriptionModule/SubscriptionHistory";

import { Switch, Route, Redirect } from "react-router-dom";
import SMROauth from "./SMR/SMROauth";
import SMRViewTickets from "./SMRAnalytics/SMRViewTickets";
import RouteWrapper from "../AppContainer/RouteWrapper";
import SMPRoutes from "./SMP/SMPRoutes";
// import NewHomePage from "./NewHomePage";
import SMRRoutes from "./SMR/SMRRoutes";
import InsightsTabContainer from "./InsightsTab/InsightsTabContainer";

const LoadableDataPage = lazy(() => import("./queryBuilder/Home/QueryBuilderMain"));
const LoadableTrendsContainer = lazy(() => import("./TrendsDataContainer/TrendsDataContainer"));
const LoadableYoutubeContainer = lazy(() => import("./TrendsDataContainer/YoutubeDataContainer"));
const LoadableReports = lazy(() => import("./Reports/Reports"));
const LoadableReportsModal = lazy(() => import("./Reports/CreateModal/CreateModal"));
const LoadableAlertsModal = lazy(() => import("./Alerts/CreateModal/CreateModal"));
const LoadableReportsAlerts = lazy(() => import("./Alerts/Alerts"));
const LoadableCollections = lazy(() => import("./Collections/CollectionsContainer"));
const LoadableProfile = lazy(() => import("./Profile/ProfileContainer"));
const LoadableDataUsage = lazy(() => import("./DataUsage/DataUsage"));
const LoadableDataUsageAnalytics = lazy(() => import("./DataUsage/DataUsageAnalytics/DataUsageAnalytics"));
const LoadableDownloads = lazy(() => import("./Downloads/Downloads"));
const LoadableNotification = lazy(() => import("./Notifications/NotificationContainer"));
const LoadableSocialTokens = lazy(() => import("./Tokens/SocialTokens"));
const LoadableEnhancedInsights = lazy(() => import("./EnhancedInsights/EnhancedInsights"));
const LodableSupport = lazy(() => import("../Support/Support"));
const LoadableTutorialRoutes = lazy(() => import("./Tutorials/TutorialRoutes"));

class MainContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
        };
    }

    shouldCollapseMainContent = () => {
        let flag = true;
        [
            "all/",
            "my/",
            "standard/",
            "my/",
            "favorites/",
            "recent/",
            "temporary/",
            "/search",
            "collections/",
            "/inbox",
            "/create-post",
            "/social-media-publishing/dashboard",
            "social-media-publishing/published",
            "social-media-publishing/failed",
            "social-response/keyword-synced-tickets",
        ].forEach((p) => {
            if (this.props.location.pathname.includes(p)) flag = false;
        });

        return flag;
    };
    isInsightsRecommendationEnabled = () => {
        let flag = false;
        ["home", "dashboard"].forEach((p) => {
            if (this.props.location.pathname.includes(p)) flag = true;
        });
        if (this.props.location.pathname.includes("social-response")) flag = false;

        return flag;
    };

    getExpandedClassName = () => {
        const className = this.props.sidebarExpanded && this.shouldCollapseMainContent() ? "sidebar-expanded" : "sidebar-collapsed";
        return className;
    };

    render() {
        let pathnameEnabledForInsightsRecommendation = this.isInsightsRecommendationEnabled();
        let themeMode = this.props.themeMode;
        let user_role = "";
        if (this.props.user.roles.includes("admin") || this.props.user.roles.includes("cxm") || this.props.user.roles.includes("companyadmin")) {
            user_role = "admin";
        } else if (this.props.user.roles.includes("cxa")) {
            user_role = "userWithSmr";
        } else {
            user_role = "user";
        }

        let percent = 0;
        if (
            this.props.user?.roles.includes("admin") ||
            this.props.user?.roles.includes("cxm") ||
            this.props.user?.roles.includes("companyadmin") ||
            this.props.user?.roles.includes("cxa")
        ) {
            if (this.props.user?.roles.includes("admin") || this.props.user?.roles.includes("cxm") || this.props.user.roles.includes("companyadmin")) {
                if (this.props.packageObj?.features?.owned_page_analytics.quota == 0)
                    percent = Math.round((this.props.progressFields?.sections?.length / 10) * 100);
                else percent = Math.round((this.props.progressFields?.sections?.length / 11) * 100);
            } else {
                if (this.props.packageObj?.features?.owned_page_analytics.quota == 0)
                    percent = Math.round((this.props.progressFields?.sections?.length / 9) * 100);
                else percent = Math.round((this.props.progressFields?.sections?.length / 10) * 100);
            }
        } else {
            if (this.props.packageObj?.features?.owned_page_analytics.quota == 0) percent = Math.round((this.props.progressFields?.sections?.length / 8) * 100);
            else percent = Math.round((this.props.progressFields?.sections?.length / 9) * 100);
        }
        return (
            <div
                id="mainContent"
                className={`mainContent ${themeMode} ${
                    this.props.location.pathname.includes("home") ? "home_page notranslate" : ""
                } ${this.getExpandedClassName()}`}>
                <Suspense fallback={<Loader />}>
                    <Switch>
                        <SubscriptionRoute path="/owned-page" component={LoadableEnhancedInsights} />
                        <RouteWrapper path="/twitter-trends" component={LoadableTrendsContainer} />
                        <RouteWrapper path="/youtube-trends" component={LoadableYoutubeContainer} />
                        <RouteWrapper path="/reports" component={LoadableReports} />
                        <SubscriptionRoute path="/createreports" component={LoadableReportsModal} />
                        <RouteWrapper path="/editreports" render={(props) => <LoadableReportsModal {...props} isEditPage={true} />} />
                        <SubscriptionRoute path="/createalerts" component={LoadableAlertsModal} />
                        <RouteWrapper path="/editalerts" render={(props) => <LoadableAlertsModal {...props} isEditPage={true} />} />
                        <RouteWrapper path="/alerts" component={LoadableReportsAlerts} />
                        <RouteWrapper path="/collections/:id" component={CollectionsPostsPage} />
                        <RouteWrapper path="/collections" component={LoadableCollections} />
                        <RouteWrapper path="/downloads" component={LoadableDownloads} />
                        <RouteWrapper path="/home" component={HomePage} />
                        <RouteWrapper path="/gettingStarted" component={GettingStarted} />
                        <RouteWrapper path="/notification" component={LoadableNotification} />
                        <RouteWrapper path="/profile" component={LoadableProfile} />
                        <RouteWrapper path="/data-usage/overview" component={LoadableDataUsage} />
                        <RouteWrapper path="/data-usage/analytics" component={LoadableDataUsageAnalytics} />
                        <RouteWrapper path="/social-tokens" component={LoadableSocialTokens} />
                        <RouteWrapper path="/dashboard" component={DashboardRoute} />
                        <RouteWrapper path="/temporary/:id" component={TemporaryPage} />
                        <RouteWrapper path="/search" component={ResearchPage} />
                        <RouteWrapper path="/data" component={LoadableDataPage} />
                        <RouteWrapper
                            path={[
                                "/social-response/oauth-callback/inbox",
                                "/social-response/oauth-callback/settings",
                                "/social-media-publishing/oauth-settings/accounts",
                            ]}
                            component={SMROauth}
                        />
                        <RouteWrapper path="/social-response/view-tickets/:id" component={SMRViewTickets} />
                        <RouteWrapper path="/support" component={LodableSupport} />
                        <RouteWrapper path="/tutorials" component={LoadableTutorialRoutes} />
                        <RouteWrapper path="/social-media-publishing" component={SMPRoutes} />
                        <RouteWrapper path="/social-response" component={SMRRoutes} />
                        <Redirect to="/home" />
                    </Switch>
                </Suspense>

                {
                    // insightsGenieAccess.includes(this.props.companyLteId) &&
                    pathnameEnabledForInsightsRecommendation ? <InsightsTabContainer /> : null
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeMode: state.globalReducer.themeMode,
        sidebarExpanded: state.globalReducer.sidebarExpanded,
        showGettingStarted: state.globalReducer.showGettingStarted,
        user: state.globalReducer.user,
        packageObj: state.globalReducer.packageObj,
        progressFields: state.globalReducer.progressFields,
        company: state.globalReducer.company,
        freeTrialDaysLeft: state.globalReducer.freeTrialDaysLeft,
        companyLteId: state.globalReducer.company?.lite_company_id,
        //  activeModule : state.sidebarReducer.activeModule
    };
};

export default connect(mapStateToProps)(MainContent);
